import {
  Button,
  Drawer,
  TableHead,
  TablePagination,
  TableRow,
} from '@material-ui/core';
import { COLORS } from 'constants/design';
import styled from 'styled-components';

export const Container = styled.div`
  margin-top: 50px;
  background-color: white;
  border-radius: 4px;
  box-shadow: 0px 1px 3px rgba(0, 0, 0, 0.12);
`;

export const Header = styled.div`
  display: flex;
  padding: 16px;
  justify-content: space-between;
`;

export const Title = styled.h2`
  color: ${COLORS.ACCORDION_TEXT_BLUE};
  font-size: 18px;
`;

export const StyledTableHead = styled(TableHead)`
  background-color: ${COLORS.TABLE_HEADER_BG};
  font-weight: 500;
`;

export const StyledTablePagination = styled(TablePagination)`
  display: block;
  color: ${COLORS.LIGHT_GREY};
`;

export const StyledTableRow = styled(TableRow)`
  cursor: pointer;
`;

export const StyledDrawer = styled(Drawer)`
  .MuiDrawer-paperAnchorRight {
    width: 400px;
  }
`;

export const ProcessButton = styled(Button)`
  color: ${COLORS.LIGHT_GREY};
  &:hover {
    background-color: transparent;
  }
`;
